<template>
  <div id="app">
    <Header/>
    <sliding-header :threshold-hide="200" :threshold-open="400">
      <template v-slot:second-header>
        <div id="nav">
          <router-link to="/">Home</router-link>
        </div>
      </template>
    </sliding-header>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/FooterTop.vue'
import SlidingHeader from '@vuesence/sliding-header'

export default {
  name: 'Nav',
  components: {
    Header,
    SlidingHeader,
    Footer
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@200;300;400&display=swap');

body{
  margin: 0;
}

#app {
  font-family: 'Source Code Pro', monospace;
  font-weight: 200;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  font-family: 'Source Code Pro', monospace;
  font-weight: 400;

  a {
    color: #ffffff;
    text-decoration: unset;
  }
}

.sliding-header {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.sliding-header.second-header {
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
  background-color: #1D1E2C;
  height: 60px;
  z-index: 99;
}

.sliding-header.hidden {
  top: -100px;
}

</style>
